// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__1urkY","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__3X-9c"};